<template>
  <v-dialog v-model="dialogframeboton" persistent max-width="1000px">
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-archive</v-icon> Seguimiento Auditoria - Solicitud:
          {{ NumeroSolicitud }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframeboton = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <proceso-auditoria
          v-if="dialogframeboton"
          :NumeroSolicitud="NumeroSolicitud"
          :datoid="infoaudi.Dato"
        ></proceso-auditoria>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    :custom-filter="multiFilter"
    class="elevation-1"
    density="compact"
    height="500"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-switch
          v-model="datoses"
          label="Datos especificos:"
          color="red-darken-4"
          @change="getHistoricoDatos()"
          hide-details
          inset
        ></v-switch>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.Dato="{ item }">
      <div>
        {{ item.raw.Dato + "-" + item.raw.DescDato }}
      </div>
    </template>
    <template v-slot:item.Valor_Unico="{ item }">
      <div>
        {{ item.raw.Valor_Unico + " " + item.raw.DescValor_Unico }}
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-tooltip
        v-if="item.raw.AuditoriaDato == 'S'"
        location="bottom"
        color="white"
      >
        <template v-slot:activator="{ props }">
          <v-icon
            @click="AuditoriaDato(item.raw)"
            color="red-darken-4"
            v-bind="props"
            >mdi-archive</v-icon
          >
        </template>
        <span>Auditoría</span>
      </v-tooltip>
    </template>
  </v-data-table>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AuditoriaDato from "@/views/TCI/ProcesosO/AuditoriaDato/AuditoriaDato.vue";
export default {
  name: "Auditoria",
  components: {
    "proceso-auditoria": AuditoriaDato,
  },
  props: {
    NumeroSolicitud: {
      type: Number,
      default: 0,
      Description: "Numero de Solicitud",
    },
    ProcesoActual: {
      type: Number,
      default: 0,
      Description: "Proceso Actual",
    },
  },
  data() {
    return {
      search: "",
      progreso: false,
      dialogframeboton: false,
      datoses: false,
      infoaudi: [],
      headers: [
        {
          title: "Dato",
          align: "start",
          key: "Dato",
        },
        {
          title: "Contenido Dato",
          align: "start",
          key: "Valor_Unico",
        },
        {
          title: "Usuario Actualizó",
          align: "start",
          key: "DescUsuarioActualizacion",
        },
        {
          title: "Fecha Actualizó",
          align: "start",
          key: "FechaActualizacion",
        },
        {
          title: "Auditoría",
          align: "center",
          key: "actions",
        },
      ],
      desserts: [],
    };
  },
  methods: {
    multiFilter(value, search, item) {
      console.log(search);
      console.log(item);
      console.log(value);
      if (!search) return true;

      search = search.toLowerCase();

      return (
        String(item.raw.Dato ?? "")
          .toLowerCase()
          .includes(search) ||
        String(item.raw.Valor_Unico ?? "")
          .toLowerCase()
          .includes(search) ||
        String(item.raw.DescDato ?? "")
          .toLowerCase()
          .includes(search) ||
        String(item.raw.DescValor_Unico ?? "")
          .toLowerCase()
          .includes(search)
      );
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Consulta Solicitudes
    async getHistoricoDatos() {
      this.desserts = [];
      this.progreso = true;
      this.axios
        .get(
          "/Procesos/NumeroSolicitudDato/getDatosSolicitiud/" +
            this.NumeroSolicitud +
            "/" +
            this.datoses +
            "/" +
            this.ProcesoActual,
        )
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    AuditoriaDato(data) {
      this.dialogframeboton = true;
      this.infoaudi = data;
    },
    ///////////////////////////////////////////////// Métodos de acciones //////////////////////////////////////////
  },
  mounted() {
    this.getHistoricoDatos();
  },
};
</script>
